import React, { useState, useEffect } from 'react'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import DelimiterDialog from '../../../TemplateProperties/DelimiterDialog';

const ReplacementModal = ({ openModal, closeModal, inputValue, handleValue, plugin = false }) => {
    const { t } = useTranslation();
    const [openDelimiterDialog, setOpenDelimiterDialog] = useState();
    const [currentValue, setCurrentValue] = useState(inputValue);

    const handleCurrentValue = (val) => {
        if (val === 'CRLF') {
            handleValue(val);
            return;
        }
        let newVal = currentValue + val;
        if (newVal?.endsWith('CRLF')) {
            setCurrentValue(currentValue + '\n')
        } else setCurrentValue(newVal);
        handleValue(newVal);
    }

    const doneWithUpdatedValue = (val) => {
        closeModal(val);
    }

    const closeModalWithValue = () => {
        closeModal(inputValue);
    }

    useEffect(() => {
        setCurrentValue(inputValue)
    }, [openModal]);

    return (
        <>
            <Dialog
                open={openModal}
                fullWidth={true}
                maxWidth={'md'}
                onClose={() => closeModalWithValue(currentValue)}
                className="dialog-header"
            >
                <DialogTitle>{t('LBL_BG_CLIENT')}</DialogTitle>
                <DialogContent>
                    <FormControl className="width-100" size="small">
                        <TextField
                            variant="outlined"
                            size="small"
                            type="text"
                            multiline
                            rows={4}
                            className={"width-100"}
                            value={currentValue || ''}
                            onChange={(e) => setCurrentValue(e.target.value)}
                        />
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Box sx={{ display: 'flex', gap: '10px', mr: '15px' }}>
                        <Button
                            variant="outlined"
                            size="small"
                            onClick={() => setOpenDelimiterDialog(true)}
                        >
                            {t('BTN_CHARACTER_TABLE')}
                        </Button>
                        <Button
                            variant="outlined"
                            size="small"
                            onClick={() => doneWithUpdatedValue(currentValue)}
                        >
                            {t('BTN_DONE')}
                        </Button>
                        {plugin && <Button
                            variant="outlined"
                            size="small"
                            onClick={() => closeModalWithValue()}
                        >
                            {t('BTN_CANCEL')}
                        </Button>}
                    </Box>
                </DialogActions>
            </Dialog>
            <DelimiterDialog
                modalOpen={openDelimiterDialog}
                close={() => setOpenDelimiterDialog(false)}
                handleInput={handleCurrentValue}
                val={''}
                name={'EOD_TERMINATOR'}
                from={'EOD_TERMINATOR'}
            >
            </DelimiterDialog>
        </>
    )
}

export default ReplacementModal